import breakpoints from '../breakpoints';
import objectParser from '../utils/object-parser';

async function initialise(el) {
  const { default: Glide } = await import('@glidejs/glide');
  const options = objectParser(el.dataset);

  new Glide(el, {
    type: 'carousel',
    perView: options.perView ?? 1,
    gap: 0,
    autoplay: options.autoplay ?? false,
    classes: {
      type: {
        slider: 'is-init',
        carousel: 'is-init'
      },
      direction: {
        ltr: 'is-ltr',
        rtl: 'is-rtl'
      },
      swipeable: 'is-swipeable',
      dragging: 'is-dragging',
      nav: {
        active: "is-active"
      },
      slide: {
        active: 'is-active',
        clone: 'is-clone'
      },
      arrow: {
        disabled: 'is-disabled'
      }
    },
    breakpoints: {
      [breakpoints.medium]: {
        perView: 1
      }
    }    
  }).mount();
}

document.addEventListener("DOMContentLoaded", (event) => {
  document.querySelectorAll('.js-Slider').forEach(el => 
    initialise(el)
  );
});